import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { store } from './helpers';

// Bootstrap 4.1.1
import "./assets/js/jquery.js";

import 'bootstrap';

/// Admin LTE
// For base styling and layout
import 'admin-lte/dist/css/AdminLTE.min.css';
import 'admin-lte/dist/js/adminlte.min.js';

import './assets/css/fontawesome/fontawesome-all-5.0.13.min.css';

import 'react-datepicker/dist/react-datepicker.css';

import './assets/css/app.css';
import './assets/css/main.css';


import { App } from './app';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js